import * as React from "react";
import { forwardRef } from "react";
const SvgIconPrev = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M19 20L9 12L19 4V20Z" fill="#CCCCCC" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><path d="M5 19V5" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>;
const ForwardRef = forwardRef(SvgIconPrev);
export { ForwardRef as ReactComponent };